/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActualsDefinitionsDataTypes {
    Integer = 0,
    Decimal = 1,
    Time = 2,
    Text = 3,
    Formula = 4,
    Boolean = 5,
    Date = 6,
}
